import { Box, Button, Card, Grid, TextField } from '@mui/material'
import { message } from 'antd'
import { useMemo, useState } from 'react'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import useAxios from '../../../../hooks/useAxios'
import SearchIcon from '@mui/icons-material/Search'
import AiMessagesTable, {
  IAiMessage,
  IAiMessagesResponse,
  IAiMessageFilter,
} from './components/AiMessagesTable'

const Menus: any[] = []

const AiMessageListPage = () => {
  const [filter, setFilter] = useState<IAiMessageFilter>({
    page: 1,
    perPage: 10,
  })
  const [searchText, setSearchText] = useState<string>('')
  const query = useMemo(() => {
    const params = new URLSearchParams()
    params.set('page', String(filter.page))
    params.set('perPage', String(filter.perPage))
    if (filter.search) params.set('search', filter.search)
    return `/ai-messages?${params.toString()}`
  }, [filter])

  const { data, isLoading, mutate, error } = useAxios<IAiMessagesResponse>({
    method: 'GET',
    url: query,
  })

  if (error) {
    message.error('โหลดข้อมูลไม่สำเร็จ')
  }

  const onPageChange = (next: IAiMessageFilter) => setFilter(next)
  const onRefresh = () => mutate()

  const onSearch = () => {
    setFilter({ ...filter, page: 1, search: searchText || undefined })
  }

  const records: IAiMessage[] = data?.records || []
  const total: number = data?.count || 0

  return (
    <ContentWrapper>
      <Helmet title={`รายการแจ้งเตือน AI`} />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title={`รายการแจ้งเตือน AI`}
            routes={Menus}
            descriptions={''}
          />
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        {/* search filter */}
        <Box mb={2} display="flex" gap={1} alignItems={'center'}>
          <TextField
            fullWidth
            label="พิมพ์ข้อความเพื่อค้นหา"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <Button
            size="large"
            variant="contained"
            onClick={onSearch}
            startIcon={<SearchIcon />}
            sx={{ px: 5 }}
          >
            ค้นหา
          </Button>
        </Box>

        <AiMessagesTable
          isLoading={isLoading}
          data={records}
          total={total}
          filter={filter}
          onPageChange={onPageChange}
          onRefresh={onRefresh}
        />
      </Card>
    </ContentWrapper>
  )
}

export default AiMessageListPage
